class TOCWidget {

    contentAreaEl;
    contentAreaSidebarEl;
    singleTOCWidgetEl;
    singleTOCWidgetHeaderEl;
    singleTOCWidgetBodyEl;
    singleTOCWidgetListEl;
    singleTOCWidgetMobileToggleBtn;
    parsedHeadings;
    siteHeader;

    constructor() {

        this.contentAreaSidebarEl = document.querySelector(".dsd-content-area-with-toc-sidebar");
        if (!this.contentAreaSidebarEl) {
            return;
        }

        this.singleTOCWidgetEl = document.querySelector(".dsd-content-area-with-toc-sidebar-toc-widget");
        if (!this.singleTOCWidgetEl) {
            return;
        }

        this.singleTOCWidgetHeaderEl = this.singleTOCWidgetEl.querySelector(".dsd-content-area-with-toc-sidebar-toc-widget__header");
        if (this.singleTOCWidgetHeaderEl === null) {
            return;
        }

        this.singleTOCWidgetMobileToggleBtn = this.singleTOCWidgetEl.querySelector(".dsd-content-area-with-toc-sidebar-toc-widget__mobile-toggle-btn");
        if (!this.singleTOCWidgetMobileToggleBtn) {
            return;
        }

        this.singleTOCWidgetBodyEl = this.singleTOCWidgetEl.querySelector(".dsd-content-area-with-toc-sidebar-toc-widget__body");
        if (this.singleTOCWidgetBodyEl === null) {
            return;
        }

        // Getting Single Post Content element
        this.contentAreaEl = document.querySelector(".dsd-content-area-with-toc-body");
        if (!this.contentAreaEl) {
            return;
        }

        // Getting Site Header (to get its height in the future)
        this.siteHeader = document.querySelector("header .main-nav");
        if (!this.siteHeader) {
            return;
        }

        // Getting ViewPort Width
        const viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

        // Looking for Headings Root Level or setting it to 1 by default
        let headingsRootLevel = this.singleTOCWidgetEl.dataset.headingsRootLevel;
        if (!headingsRootLevel) {
            headingsRootLevel = "1";
        }

        // Building list of the Headings to select
        let headingsToSelect = [];
        for (let i = parseInt(headingsRootLevel); i <= 6; i++) {
            headingsToSelect.push("h" + i.toString());
        }

        // Parsed Headings from Content
        this.parsedHeadings = this.contentAreaEl.querySelectorAll(headingsToSelect.join(", "));

        // Trying to build the TOC
        try {
            // Init Widget building
            this.buildTOCStructure(parseInt(headingsRootLevel), viewportWidth);

            // Highlighting the List Items
            document.addEventListener("scroll", () => {

                const tocLinks = this.singleTOCWidgetListEl.querySelectorAll("a");

                this.parsedHeadings.forEach(heading => {
                    tocLinks.forEach(tocLink => {

                        if (tocLink.href.split("#")[1] === heading.id) {
                            if (this.isHeadingInViewport(heading)) {
                                tocLink.classList.add("dsd-highlight");
                            } else {
                                tocLink.classList.remove("dsd-highlight");
                            }
                        }

                    });
                })
            });
        } catch (error) {

            // Creating Error Message markup
            const errorEl = document.createElement("div");
            errorEl.classList.add("dsd-content-area-with-toc-sidebar-toc-widget-error");

            const errorMessageEl = document.createElement("h5");
            errorMessageEl.classList.add("dsd-content-area-with-toc-sidebar-toc-widget-error__message");

            if (error instanceof Error) {
                errorMessageEl.innerText = error.message;
            } else {
                errorMessageEl.innerText = 'Unexpected error - ' + error;
            }

            // Appending Error Message to the Error El
            errorEl.appendChild(errorMessageEl);

            // Appending the Error Message Element to the TOC Body
            this.singleTOCWidgetBodyEl.appendChild(errorEl);
        }

        // Making TOC Widget fixed on mobiles on scroll
        if (viewportWidth <= 980) {
            const threshold = this.contentAreaSidebarEl.getBoundingClientRect().top + window.scrollY - this.siteHeader.clientHeight - this.singleTOCWidgetHeaderEl.clientHeight;

            document.addEventListener("scroll", () => {
                if (this.singleTOCWidgetEl === null) {
                    return;
                }

                if (window.scrollY >= threshold) {
                    this.contentAreaSidebarEl.classList.add('dsd-content-area-with-toc-sidebar_fixed');
                    this.singleTOCWidgetEl.classList.add('dsd-content-area-with-toc-sidebar-toc-widget_mob-compressed');

                    if (this.singleTOCWidgetMobileToggleBtn.innerText === "Close") {
                        this.singleTOCWidgetMobileToggleBtn.innerText = "Open";
                    }

                } else {
                    this.contentAreaSidebarEl.classList.remove('dsd-content-area-with-toc-sidebar_fixed');
                    this.singleTOCWidgetEl.classList.remove('dsd-content-area-with-toc-sidebar-toc-widget_mob-compressed');
                }
            });

            // Making TOC Widget Collapsible on mobiles
            this.singleTOCWidgetHeaderEl.addEventListener("click", () => {
                if (this.singleTOCWidgetEl === null || !this.contentAreaSidebarEl.classList.contains('dsd-content-area-with-toc-sidebar_fixed')) {
                    return;
                }

                this.singleTOCWidgetEl.classList.toggle("dsd-content-area-with-toc-sidebar-toc-widget_mob-compressed");

                if (this.singleTOCWidgetMobileToggleBtn.innerText === "Open") {
                    this.singleTOCWidgetMobileToggleBtn.innerText = "Close";
                } else {
                    this.singleTOCWidgetMobileToggleBtn.innerText = "Open";
                }
            });
        }

    }

    /**
     * Checking if Heading is in Viewport
     * @param el {HTMLHeadingElement}
     * @returns {boolean}
     */
    isHeadingInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)

        );
    }

    /**
     * @param {number} headingsRootLevel
     * @param {number} viewportWidth
     */
    buildTOCStructure(headingsRootLevel, viewportWidth) {

        // Checking TOC Widget Body El
        if (!this.singleTOCWidgetBodyEl) {
            throw new Error("There is no TOC Widget Body Element markup");
        }

        // Checking Parsed Headings
        if (!this.parsedHeadings || this.parsedHeadings.length === 0) {
            throw new Error("There are no Headings in the Content");
        }

        // Checking the Root Level of Heading
        if (headingsRootLevel !== parseInt(this.parsedHeadings[0].nodeName.substring(1))) {
            throw new Error("The configured Root Headline has incorrect Level");
        }

        // Creating TOC List element dynamically
        this.singleTOCWidgetListEl = document.createElement("ul");

        // Adding the class to the List
        this.singleTOCWidgetListEl.classList.add("dsd-content-area-with-toc-sidebar-toc-widget__list");

        let previousLevel = headingsRootLevel;
        let parentList = this.singleTOCWidgetListEl;

        // Going through the all Parsed Headlines
        this.parsedHeadings.forEach((heading, index) => {

            // Creating ListItem
            const tocListItem = document.createElement("li");

            // Creating the Link to the Related Element
            const tocLinkEl = document.createElement("a");

            // Passing the Text of the Headline to the Related Link in the TOC
            tocLinkEl.innerText = heading.innerText;

            // Creating ID for the Heading (anchor)
            const headingId = heading.innerText.replace(/ /g, "-").replace(/[^a-zA-Z0-9 ]/g, '').toLocaleLowerCase() + "-" + index;

            // Adding ID to the Heading
            heading.id = headingId;

            // Generating href for the link (anchor link)
            tocLinkEl.href = "#" + headingId;

            // Inserting the Link into the Created earlier List Item
            tocListItem.appendChild(tocLinkEl);

            tocLinkEl.addEventListener("click", ev => {
                ev.preventDefault();

                const headlineScrollTo = document.querySelector("#" + headingId);
                if (headlineScrollTo === null) {
                    return;
                }

                let headlineYCoord = headlineScrollTo.getBoundingClientRect().top + window.scrollY - this.siteHeader.clientHeight - 15;

                if (viewportWidth < 980) {
                    headlineYCoord = headlineYCoord - this.singleTOCWidgetHeaderEl.clientHeight;

                    // If Sidebar is not fixed in the moment of clicking to the link, then we decrease the scroll coord
                    if (!this.contentAreaSidebarEl.classList.contains("dsd-content-area-with-toc-sidebar_fixed")) {
                        headlineYCoord = headlineYCoord - this.contentAreaSidebarEl.clientHeight;
                    }
                }

                window.scrollTo({
                    top: headlineYCoord,
                    behavior: "smooth"
                });
            });

            // Determine heading level and create nested list if necessary
            const currentLevel = parseInt(heading.nodeName.substring(1));

            if (currentLevel > previousLevel) {
                // Create a nested list
                const nestedList = document.createElement('ul');

                parentList.lastChild.appendChild(nestedList);
                parentList = nestedList;

            } else if (currentLevel < previousLevel) {
                // Move back to the previous list
                let levelsToMoveUp = previousLevel - currentLevel;
                while (levelsToMoveUp > 0) {
                    if (parentList.parentNode === null) {
                        throw new Error("The hierarchy of Headings is built incorrectly. Thus, the TOC can't be generated :(");
                    }

                    parentList = parentList.parentNode.parentNode;
                    levelsToMoveUp--;
                }
            }

            parentList.appendChild(tocListItem);
            previousLevel = currentLevel;

        });

        // Append TOC List to the TOC Body Element
        this.singleTOCWidgetBodyEl.appendChild(this.singleTOCWidgetListEl);

    }

}

export default TOCWidget;